export default "__VITE_ASSET__B$pm7iFx__"